import { LayoutType } from 'gleblu-socket-api';
import { createAction } from 'redux-act';

import Layout from '../../../models/interfaces/layout/Layout';
import MergedTable from '../../../models/interfaces/layout/MergedTable';
import Table from '../../../models/interfaces/layout/Table';
import TableType from '../../../models/interfaces/layout/TableType';
import LayoutPayload from './LayoutPayload';

export interface CreateLayoutPayload extends LayoutPayload {
  placeUuid: string;
  label: string;
  type: LayoutType;
}
export const createLayout = createAction<CreateLayoutPayload>('CREATE_LAYOUT');

export interface LayoutCreatedPayload extends LayoutPayload {
  placeUuid: string;
  layout: Layout;
  mergedTables: MergedTable[];
  tables: Table[];
  tableTypes: TableType[];
}
export const layoutCreated = createAction<LayoutCreatedPayload>('LAYOUT_CREATED');

export type LayoutCreateFailedPayload = LayoutPayload;
export const layoutCreateFailed = createAction<LayoutCreateFailedPayload>('LAYOUT_CREATE_FAILED');
